import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Navbar, Button, Alignment, Classes, Icon } from '@blueprintjs/core';

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isMobileMenuOpen]);

  const isActive = (paths) => {
    const pathList = Array.isArray(paths) ? paths : [paths];
    // Handle root path - it defaults to Analytics
    if (location.pathname === '/' && pathList.includes('/analytics')) return true;
    // Direct path matching
    return pathList.includes(location.pathname);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <div className={`${Classes.DARK} bp5-dark`} style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar>
        <Navbar.Group align={Alignment.LEFT}>
          <Button
            className={`${Classes.MINIMAL} mobile-menu-button`}
            icon="menu"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          />
          <Navbar.Heading>ACT — Scorecard</Navbar.Heading>
          <Navbar.Divider />
          <Button
            className={Classes.MINIMAL}
            icon="edit"
            text="Scorecard"
            intent={isActive('/scorecard') ? 'primary' : 'none'}
            onClick={() => navigate('/scorecard')}
          />
          <Button
            className={Classes.MINIMAL}
            icon="history"
            text="History"
            intent={isActive('/history') ? 'primary' : 'none'}
            onClick={() => navigate('/history')}
          />
          <Button
            className={Classes.MINIMAL}
            icon="chart"
            text="Analytics"
            intent={isActive('/analytics') ? 'primary' : 'none'}
            onClick={() => navigate('/analytics')}
          />
          <Button
            className={Classes.MINIMAL}
            icon="timeline-bar-chart"
            text="ELO History"
            intent={isActive('/elo-history') ? 'primary' : 'none'}
            onClick={() => navigate('/elo-history')}
          />
          <Button
            className={Classes.MINIMAL}
            icon="applications"
            text="Other"
            intent={isActive(['/other', '/team-maker', '/sat-history']) ? 'primary' : 'none'}
            onClick={() => navigate('/other')}
          />
        </Navbar.Group>
      </Navbar>
      
      {/* Mobile Navigation Drawer */}
      {isMobileMenuOpen && (
        <div className="mobile-nav-overlay" onClick={() => setIsMobileMenuOpen(false)} />
      )}
      <div className={`mobile-nav-drawer ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav-header">
          <h3 style={{ margin: 0, color: 'var(--text-primary)' }}>Navigation</h3>
          <Button
            className={Classes.MINIMAL}
            icon="cross"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        </div>
        <div className="mobile-nav-links">
          <Button
            className={Classes.MINIMAL}
            icon="edit"
            text="Scorecard"
            intent={isActive('/scorecard') ? 'primary' : 'none'}
            onClick={() => handleNavigation('/scorecard')}
            style={{ width: '100%' }}
          />
          <Button
            className={Classes.MINIMAL}
            icon="history"
            text="History"
            intent={isActive('/history') ? 'primary' : 'none'}
            onClick={() => handleNavigation('/history')}
            style={{ width: '100%' }}
          />
          <Button
            className={Classes.MINIMAL}
            icon="chart"
            text="Analytics"
            intent={isActive('/analytics') ? 'primary' : 'none'}
            onClick={() => handleNavigation('/analytics')}
            style={{ width: '100%' }}
          />
          <Button
            className={Classes.MINIMAL}
            icon="timeline-bar-chart"
            text="ELO History"
            intent={isActive('/elo-history') ? 'primary' : 'none'}
            onClick={() => handleNavigation('/elo-history')}
            style={{ width: '100%' }}
          />
          <Button
            className={Classes.MINIMAL}
            icon="applications"
            text="Other"
            intent={isActive(['/other', '/team-maker', '/sat-history']) ? 'primary' : 'none'}
            onClick={() => handleNavigation('/other')}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      
      <div className="main-container" style={{ flex: 1, overflow: 'auto' }}>
        {children}
      </div>
    </div>
  );
}

export default Layout;
